<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Production Item Code"
                  v-model="productionItem.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="name"
                  label="Production Item Name"
                  v-model="productionItem.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="productionItem.description"
                  type="text"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productionItem.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productionItem.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="productionItem.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productionItem.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="productionItem.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="productionItem.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="productionItem.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addProductionItemDertail()">
                    Add Detail
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs4>Process Name</v-flex>
                  <v-flex xs4>Percentage(%)</v-flex>
                  <v-flex xs3>Remark</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(
                    detail, index
                  ) in productionItem.productionItemDetailList"
                  :key="index"
                >
                  <v-flex xs4>
                    <v-text-field
                      placeholder="Process Name"
                      v-model="detail.processName"
                      type="text"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      placeholder="Percentage"
                      v-model="detail.percentage"
                      :rules="
                        rules.geraterThanzeroPercentageRules('Percentage')
                      "
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      placeholder="Remark"
                      v-model="detail.remark"
                      type="text"
                      :rules="rules.remarkRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removeProductionItemDetail(index, detail.id)"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { productionItemService } from "../../services/production-item-service";
import { ProductionItem, ProductionItemDetail } from "../../models/model";
import { ProductionItemFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "ProductionItemDetail",
  data: () => ({
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Production Item",
        disabled: false,
        to: "production-items",
      },
      {
        text: "Production Item Detail",
        disabled: true,
      },
    ],
    rules: new ProductionItemFormRules(),
    productionItem: new ProductionItem(),
    oldProductionItem: new ProductionItem(),
    updatedDate: "",
    createdDate: "",
    responseError: "",
    statusFlag: true,
    rowsPerPageItems: [10, 50, 100],
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new production item
      this.addProductionItemDertail();
    } else {
      this.getProductionItemDetail(id);
    }
  },
  methods: {
    addProductionItemDertail() {
      let productionItemDetail = new ProductionItemDetail();
      this.productionItem.productionItemDetailList.push(productionItemDetail);
    },
    removeProductionItemDetail(index, detailId) {
      if (detailId) {
        if (!this.productionItem.deleteProductionItemDetailIds) {
          this.productionItem.deleteProductionItemDetailIds = [];
        }
        this.productionItem.deleteProductionItemDetailIds.push(detailId);
      }
      this.$delete(this.productionItem.productionItemDetailList, index);
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.productionItem.status = this.statusFlag ? "ACTIVE" : "INACTIVE";

          productionItemService
            .saveProductionItem(this.productionItem)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    getProductionItemDetail(id) {
      productionItemService
        .getProductionItemDetail(id)
        .then((res) => {
          this.productionItem = res.data;
          this.createdDate = commonService.millisecondToDate(
            this.productionItem.createdDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.millisecondToDate(
            this.productionItem.updatedDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.oldProductionItem = Object.assign({}, res.data);
          this.statusFlag =
            this.productionItem.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.productionItem.id) {
        this.productionItem = new ProductionItem();
        this.addProductionItemDertail();
        this.statusFlag = true;
      } else {
        this.productionItem = Object.assign({}, this.oldProductionItem);
        this.statusFlag = this.productionItem.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/production-items");
    },
  },
};
</script>

